import { Component, ViewChildren, ElementRef, EventEmitter, Output, QueryList, ChangeDetectionStrategy } from "@angular/core";

import { UserService, ExchangeService, WindowService, BaseComponent, ContentService, HelperService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-add-learn-video",
  templateUrl: "add-learn-video.component.html",
  standalone: false,
})
export class AddLearnVideoComponent extends BaseComponent {
  public loading: boolean = false;
  public videoId: string;
  public playlistId: string;
  public createFolder: boolean = false;
  public markApproved: boolean = true;
  public brand: string = "presonus";
  public section: string = "videoId";
  @Output() videoAdded: EventEmitter<any> = new EventEmitter();

  constructor(
    userService: UserService,
    windowService: WindowService,
    public activeModal: NgbActiveModal,
    public exchangeService: ExchangeService,
    public contentService: ContentService,
    public helperService: HelperService,
    public appService: AppService
  ) {
    super(userService);
  }

  submit() {
    this.loading = true;
    let args: any = {
      brand: this.brand,
      markApproved: this.markApproved,
    };
    if (this.section == "videoId") {
      if (!this.videoId) {
        alert("Please enter a YouTube or Vimeo video ID.");
        return;
      }
      args.videoId = this.videoId;
    } else if (this.section == "playlistId") {
      if (!this.playlistId) {
        alert("Please enter a YouTube Playlist ID.");
        return;
      }
      args.playlistId = this.playlistId;
      args.createFolder = this.createFolder;
    }

    this.contentService.addVideo(args).subscribe({
      next: (result: any) => {
        this.videoAdded.emit({
          result: result,
          type: this.section == "playlistId" ? "playlist" : "video",
        });
        this.activeModal.dismiss();
      },
      error: (err) => {
        this.loading = false;
        this.appService.alertError(err);
      },
    });
  }
}
